import React  from 'react'
import { Button, DisplayText } from '@shopify/polaris'
import RenderImages from '../render-images/RenderImages'
import SpinnerEffect from '../Spinner'
import GetIdYoutube from '../../scripts/getIdYoutube'
import GetYoutubePreview from '../../scripts/getYoutubePreview'
import './images.css';
import WarningBanner from '../WarningBanner'
import getDataLocalStorage from '../../scripts/getDataLocalStorage'
export default class Images extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: new Date().toISOString().slice(0, 10),
      dateTo: new Date().toISOString().slice(0, 10),
      minDate:'2015-01-01',
      maxDate: new Date().toISOString().slice(0, 10),
      imagesData: {},
      spinner: false,
      warningBanner: false,
      bannerEmptyFavorite: '',
      localStorageData: {},
      localStorageName: 'LocalStorageLikedImages'
    };

    this.myRefDateFrom = React.createRef();
    this.myRefDateTo = React.createRef();

    this.requestData = this.requestData.bind(this);
    this.handleChangeDateFrom = this.handleChangeDateFrom.bind(this);
    this.handleChangeDateTo = this.handleChangeDateTo.bind(this);
    this.getIdYoutube = this.getIdYoutube.bind(this);
    this.getYoutubePreview = this.getYoutubePreview.bind(this);
    this.addElementToData = this.addElementToData.bind(this);
    this.showLikedImages = this.showLikedImages.bind(this);
  }

  componentDidMount() {
    this.setState({
      localStorageData: getDataLocalStorage(this.state.localStorageName)
    });
    this.requestData();
  }

  getIdYoutube(url){
    return GetIdYoutube(url)
  }

  getYoutubePreview(id){
    return GetYoutubePreview(id)
  }

  handleChangeDateFrom(event) {
    this.setState({
      dateFrom: event.target.value
    })
  }

  handleChangeDateTo(event) {
    this.setState({
      dateTo: event.target.value
    })
  }
  addElementToData(data) {
    for (let i = 0; i < data.length; i++) { //add new element to [DATA]
      data[i]['description_short'] = data[i]['explanation'].slice(0, 80) + '...';
      if (this.state.localStorageData.hasOwnProperty(data[i]['date']) ) {
        data[i]['like'] = true;
      } else {
        data[i]['like'] = false;
      }
      
      if (data[i]['media_type'] === 'video') {
        data[i]['youtube_id'] = this.getIdYoutube(data[i]['url']);
        data[i]['youtube_preview'] = this.getYoutubePreview(data[i]['youtube_id'])
      }
      if (data[i].hasOwnProperty(['copyright'])) {
        data[i]['copyright'] = 'Copyright: ' + data[i]['copyright'];
      }
    };    
    
    let results = {}; // convert [DATA] > {DATA}  = {'2022-12-12': {date: '2021-12-26', explanation: "There's a big new }, }
    data.forEach(element => {
      results[element.date] = element
    });
    
    this.setState ({
      imagesData: results,
      spinner: false
    })
  }

  requestData() {
    this.setState({
      imagesData: {},
      spinner: true,
      bannerEmptyFavorite: '',
      warningBanner: false,
      localStorageData: JSON.parse(localStorage.getItem(this.state.localStorageName)),
      dateFrom: this.myRefDateFrom.current.value,
      dateTo: this.myRefDateTo.current.value,
    });

    let apiKey = "CeUqAfBFRcOvce7i3x1CE49qHnaaHU2ed4VUVt2V"
    let api = "https://api.nasa.gov/planetary/apod?api_key="

    fetch(api + apiKey + "&start_date=" + this.state.dateFrom + "&end_date=" + this.state.dateTo)
      .then(res => res.json())
      .then(data => {
        this.addElementToData(data);
      })
      .catch((error) => {
        this.setState({
          spinner: false,
          warningBanner: true,
        });
      })
  }

  showLikedImages(){
    this.setState({
      imagesData: JSON.parse(localStorage.getItem(this.state.localStorageName)),
      bannerEmptyFavorite: '',
    })
    if (Object.keys(JSON.parse(localStorage.getItem(this.state.localStorageName))).length === 0) {
      this.setState({
        bannerEmptyFavorite: 'Oops! You have no favorite images!'
      })
    }
  }

  render() {
    return (<div className='section-images'>
      <div className='section-images__date'>
        <button className='btn-favorite'  onClick={() => this.showLikedImages()}> <svg color="#ed4956" fill="#ed4956" height="24" role="img" viewBox="0 0 48 48" width="24"><path d="M34.6 3.1c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5s1.1-.2 1.6-.5c1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z"></path></svg></button>
        <div>
          <label 
            htmlFor="start">from:</label> 
          <input type="date" id="start" min={this.state.minDate} max={this.state.maxDate} value={this.state.dateFrom}
            onChange={this.handleChangeDateFrom}
            ref={this.myRefDateFrom}>
          </input>
        </div>
        
        <div>
          <label htmlFor="end">to:</label> 
          <input type="date" id="end" min={this.state.minDate} max={this.state.maxDate} value={this.state.dateTo}
              onChange={this.handleChangeDateTo}
              ref = {this.myRefDateTo}>
          </input>
        </div>

        <Button primary
          onClick={this.requestData}>
          Go!
        </Button>
      </div>
      
      <div className='spacer'></div>
      <SpinnerEffect 
        spinner={this.state.spinner}
      />
      <WarningBanner 
        warning_banner={this.state.warningBanner}
      />
      <DisplayText size="Large">{this.state.bannerEmptyFavorite}</DisplayText>

      <div className='spacer'></div>
      <RenderImages
          images={Object.values(this.state.imagesData)} //set Arr[{value}, {value}]
          localStorageName={this.state.localStorageName}
        />
    </div>
    );
  }
}